export const MOBILE_S_MEDIA_BREAK = 425;
export const MOBILE_MEDIA_BREAK = 768;
export const TABLET_MEDIA_BREAK = 1024;
export const LAPTOP_MEDIA_BREAK = 1280;